export class DesiredCapacity {
  id: number = 0;
  capacity: number = 0;
  effect_date: Date = new Date(0);
  end_date?: Date = new Date(0);
  comment: string="";
}